export { VITRANSFER_LANGUAGE as vitransferLanguage } from './texts'
